
class SavedOnline {
  constructor(element) {
    this.element = element;
    this.input = document.querySelector('[data-profile-filter-form="orders-active"] select');

    if (this.input) {
      this.init();
    }
  }

  init() {
    this.bind();
  }

  bind() {
    this.input.addEventListener('change', (e) => {
      this.request(e.target.value);
    });
  }

  request(storeId) {
    const csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const data = {
      [csrfParam]: csrfToken,
      storeId
    };

    const jax = new Jax('/profile/api/saved-online', 'POST', false);
    jax.send(data).then(response => {
      const data = document.createElement('div');
      data.innerHTML = response;
      const content = data.querySelector('[data-saving-online]');
      if (content) {
        this.element.innerHTML = content.innerHTML;
      }
    });
  }
}

function initSavedOnline() {
  const element = document.querySelector('[data-saving-online]');
  if (element) {
    new SavedOnline(element)
  }
}
document.addEventListener('DOMContentLoaded', initSavedOnline);